// src/queries/getProjects.ts
import datoCMSClient from './datoCMSClient';
import { Project } from '../types';

const GET_PROJECTS = `
  query {
    allProjects(orderBy: title_ASC) {
      title
      description
      techUsed
      image {
        url
      }
    }
  }
`;

// Updated fallback data for all projects with correct names
const FALLBACK_DATA: Project[] = [
  {
    title: "M8 Website",
    description: "A dynamic web platform built with React and Node.js for M8 LLC. Features user authentication, social networking, and real-time communication functionalities.",
    techUsed: "React, Node.js, Express, MongoDB, Socket.io, Redux, WebSocket",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABYkWYrmT5BQXKvR_jXsM853mY_Jv7Vx0HqrOaV5Kmy7MtTYjnUxit0R5Rm_QQBuPCTcKDl7wm2W9pJo1hUZ-nSFnCx0hTaA5jCGP.jpg?r=776" }
  },
  {
    title: "HomeHarmony", // Updated from Sub-Space
    description: "A comprehensive real estate platform built with React, TypeScript, and Supabase. Facilitates seamless interactions between buyers and sellers with robust property management and communication features.",
    techUsed: "React, TypeScript, Supabase, Tailwind CSS, Google Maps, Stripe",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABcTLdc-X_l2E6xCmYYXH9lZhCZ-74xbndj3vNBW78a7G_1KjC4oftKGy2AqOqNOJUot4NqU-5KlzX-VUO-SsVgSm5LRGEGkJOiWo.jpg?r=7c1" }
  },
  {
    title: "M8 Social Mobile",
    description: "Prototype mobile version of M8 Social Platform. Focuses on clean UI and real-time user engagement using Firebase for data sync.",
    techUsed: "React Native, TypeScript, Firebase",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABRh2jOk2QGoBcNmGW1WbJoFrT8tCPEVBjh4oi3vXnFyQPJyl4DkGEe9d_IQGNwO5oJJzUmrQJeZ4K4mC0XQMABktY6G5XYP6NcXw.jpg?r=875" }
  },
  {
    title: "FinGuard",
    description: "A browser extension and web dashboard that helps users spend smarter, stay safer, and build better financial habits. Recommends the best credit card for purchases, warns about unsafe websites, and tracks spending patterns.",
    techUsed: "React, Node.js, MongoDB, TailwindCSS, Gemini",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABSC8rJ8vPXJQsUiOKbFf3G9T6ZArI5oyy1hJgPYPzm-mOEay_mhhQEQVkNJsxz9AucJKzNj0h5Kx9_qVFc6WlHPM2BxhWDsQGRuz.jpg?r=95d" }
  },
  {
    title: "AgriScience",
    description: "Django-based platform that optimizes crop growth using real-time data and predictive analytics. Ideal for small-scale farms and provides actionable insights to enhance productivity.",
    techUsed: "Django, Python, MySQL, Bootstrap, Machine Learning, IoT Integration",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABUXEGlA6XVxWsyGJU8kgSbYQZYIdpkpO_OYH9hRFEYHfI3OMwxvFSuRCQiM6tpZ9FW2r1Hv1ZJpxxK2YbY2yBpTCVCc10ufJTMxH.jpg?r=a90" }
  },
  {
    title: "Meal Plan Optimizer",
    description: "Web application for Penn State students to analyze and optimize their campus meal plan spending. Features automated data collection, spending analytics, and personalized recommendations.",
    techUsed: "React, Firebase, TypeScript, Node.js, Puppeteer, Tailwind CSS",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABRh2jOk2QGoBcNmGW1WbJoFrT8tCPEVBjh4oi3vXnFyQPJyl4DkGEe9d_IQGNwO5oJJzUmrQJeZ4K4mC0XQMABktY6G5XYP6NcXw.jpg?r=875" }
  },
  {
    title: "SecureWater",
    description: "Advanced image watermarking system for protecting digital assets with tamper detection and verification capabilities. Built with React and Node.js.",
    techUsed: "React, Node.js, MongoDB, Sharp, Image Processing",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABZXplXUEC36kOD0zaRWj9e9tQbA5a8Dzt3KwvCFB6PvJ8j95jg_zQFv4IzMoIsm7dxzBpL5I87aAZxIFqCG3zl6hgtkSoBAB2dOt.jpg?r=c68" }
  },
  {
    title: "SAR Meditech Website",
    description: "Modern company website for medical equipment procurement firm built with Vue 3, featuring responsive design and dynamic components.",
    techUsed: "Vue 3, TailwindCSS, TypeScript",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABbWkLuqZfHzYmRk7BdCJmdwjKBT3x4XvEX9xFiXCIRfoLwRGGjkPygoXxHp-MIQnUgDN51Kl80oFEPVJp2E66S_WG1GFLHMjuXlF.jpg?r=ab2" }
  },
  {
    title: "Portfolio",
    description: "This Netflix-inspired portfolio website showcasing my projects and experience. Built with React, TypeScript, and modern web technologies.",
    techUsed: "React, TypeScript, CSS, React Router",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABbWkLuqZfHzYmRk7BdCJmdwjKBT3x4XvEX9xFiXCIRfoLwRGGjkPygoXxHp-MIQnUgDN51Kl80oFEPVJp2E66S_WG1GFLHMjuXlF.jpg?r=ab2" }
  },
  {
    title: "MyMuscle",
    description: "Your AI-powered fitness coach in your pocket — track your form, count reps, get real-time feedback, and crush your goals with personalized workouts.",
    techUsed: "React, TensorFlow, Supabase, Tailwind CSS, Gemini",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABRlH6QoNOLijQb1EiAiXcTVQV5DJMZ9jwhiPgRAmEgHiCwPGivBj6l5CoGRzT4_lv4ehzLtnwz65TJNvl87H0ZB_v7RbNXLDZnxC.jpg?r=088" }
  },
  {
    title: "JBOD System",
    description: "A JBOD (Just a Bunch of Disks) System implementation over a network, designed to provide efficient and reliable distributed data storage and retrieval.",
    techUsed: "C, Socket Programming, File Systems",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABRGxWsHwTtFXSA3D6MgVXmS4Wga8mrwQZLlWXh74lEox6i5enGxRUhK8j3VCUcFaNFTdnHlDVwYAZgE46lGqK_7QBQ2P8L3y2Jmk.jpg?r=ed1" }
  },
  {
    title: "StockFetcher",
    description: "A Django web app that provides real-time stock data analysis, backtesting capabilities, and ML-powered price predictions using financial APIs.",
    techUsed: "Django, Pandas, Scikit-learn",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABQnmN5WKpkbhphrQHg94xthwwRrUHfMkQtEwTnZ7kJ8WVwMyjqLL-FMlSkQ0nTnOmL90rlOkdVeSZxn8AvOWmPuFw8KYsez7qHwq.jpg?r=209" }
  },
  {
    title: "Course Scheduler",
    description: "Intelligent course planning tool leveraging web scraping and NLP to help students optimize their academic schedules.",
    techUsed: "NLTK, Selenium, Beautiful Soup, MongoDB, Express, React, Node.js",
    image: { url: "https://occ-0-2794-2219.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABcCAZ3tWt5Uk2K2ek-hLBgNJTvYHK-wvsB12WwpJl5Lxz85JCrMBJh2Wg5fBMJnFLGNGwHcK5A4h9jnQHmY8kXRRh1cAlhkpYLGK.jpg?r=143" }
  }
];

export async function getProjects(): Promise<Project[]> {
  try {
    const data = await datoCMSClient.request<{ allProjects: Project[] }>(GET_PROJECTS);
    return data.allProjects;
  } catch (error) {
    console.warn("Error fetching projects data, using fallback data:", error);
    return FALLBACK_DATA;
  }
}